import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ShortDtc } from '../models/dtc';

@Injectable({ providedIn: 'root' })
export class VehicleDiagnosticsService {
  constructor(private http: HttpClient) {}

  static fromJSON(res: ShortDtc): ShortDtc {
    if (res?.duration?.lower) {
      res.duration.lower = new Date(res.duration.lower);
    }
    if (res?.duration?.upper) {
      res.duration.upper = new Date(res.duration.upper);
    }
    return res;
  }

  getDtc(
    vehicleId: number,
    dateRange?: { start: Date; end: Date },
  ): Observable<ShortDtc[]> {
    let params = new HttpParams();
    if (dateRange) {
      params = params.append(
        'duration__range_lower',
        dateRange.start.toISOString(),
      );
      params = params.append(
        'duration__range_upper',
        dateRange.end.toISOString(),
      );
    } else {
      params = params.append('active', true);
    }
    return this.http
      .get<ShortDtc[]>(
        environment.apiUrl + `api/diagnostics/dtc/${vehicleId}/`,
        {
          params,
        },
      )
      .pipe(
        map((res: any) => res['results']),
        map((res): ShortDtc[] => {
          return res.map((note: ShortDtc) =>
            VehicleDiagnosticsService.fromJSON(note),
          );
        }),
      );
  }

  getMilStatus(vehicleId: number): Observable<number> {
    return this.http
      .get<{
        status: number;
      }>(environment.apiUrl + `api/diagnostics/mil/${vehicleId}/`)
      .pipe(map((res) => res.status));
  }
}
